import(/* webpackMode: "eager" */ "/app/src/app/gateway/layout.tsx");
